<template>
  <a-modal v-model:visible="visible" :title="modalTitle" :confirm-loading="confirmLoading" @ok="handleOk" @cancel="handleCancel" destroyOnClose width="650px" okText="确认提交" cancelText="取消">
    <a-spin :spinning="loading">

      <div v-if="detailData" style="margin-bottom: 24px;">
        
        <a-descriptions bordered size="small" :column="2">
          <a-descriptions-item label="关联订单">
            {{ detailData?.orderNo || '--' }}
          </a-descriptions-item>
          <a-descriptions-item label="售后类型">
            <a-tag color="orange">{{ detailData?.afterSalesOrder?.type || '--' }}</a-tag>
          </a-descriptions-item>

          <a-descriptions-item label="退款金额" v-if="detailData?.afterSalesOrder?.type === '退货退款'">
            <span style="color: #ff4d4f; font-weight: bold;">￥{{ detailData?.payAmount || '0.00' }}</span>
          </a-descriptions-item>

          <a-descriptions-item label="申请时间">
            {{ formatTime(detailData?.createdDate) || '--' }}
          </a-descriptions-item>

          <a-descriptions-item label="商品明细" :span="2">
            <div v-for="(item, index) in detailData?.items" :key="index">
              {{ item?.productName || '--' }}
              <span style="color: #888; font-size: 12px; margin-left: 8px;">
                (规格: {{ item?.sku?.name || '--' }} | 数量: {{ item?.quantity || 0 }})
              </span>
            </div>
          </a-descriptions-item>

          <a-descriptions-item label="客户留言" :span="2">
            <span style="color: #d46b08; font-weight: bold;">
              {{ detailData?.afterSalesOrder?.customerComment || '该客户未填写留言' }}
            </span>
          </a-descriptions-item>
        </a-descriptions>
        <a-divider dashed />
      </div>

      <a-form ref="formRef" :model="formState" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">

        <a-form-item v-if="opName === '售后审核'" label="审核结果" required>
          <a-radio-group v-model:value="auditResult">
            <a-radio value="pass">审核通过</a-radio>
            <a-radio value="reject">审核拒绝</a-radio>
          </a-radio-group>
        </a-form-item>

        <template v-if="actualOpName === '售后审核通过'">
          <a-alert message="即将通过该售后申请，请确认或补充以下信息" type="info" show-icon style="margin-bottom: 20px;" />

          <template v-if="detailData?.afterSalesOrder?.type === '补寄'">
            <a-form-item label="补寄物流公司" name="expressCompanyName" :rules="[{ required: true, message: '请输入物流公司' }]">
              <a-input v-model:value="formState.expressCompanyName" placeholder="商家发货的物流公司" />
            </a-form-item>
            <a-form-item label="补寄物流单号" name="trackingNumber" :rules="[{ required: true, message: '请输入物流单号' }]">
              <a-input v-model:value="formState.trackingNumber" placeholder="商家发货的单号" />
            </a-form-item>
          </template>

          <template v-if="detailData?.afterSalesOrder?.type === '退货退款'">
            <a-form-item label="退款说明">
              <span>系统将按上述金额 (￥{{ detailData?.payAmount }}) 发起退款</span>
            </a-form-item>
          </template>

          <a-form-item label="内部备注" name="serviceComment">
            <a-textarea v-model:value="formState.serviceComment" placeholder="审核通过的内部备注（选填）" :rows="2" />
          </a-form-item>
        </template>

        <template v-else-if="actualOpName === '售后审核拒绝'">
          <a-form-item label="拒绝原因" name="serviceComment" :rules="[{ required: true, message: '请输入拒绝原因' }]">
            <a-textarea v-model:value="formState.serviceComment" placeholder="必须填写拒绝原因，将展示给客户看" :rows="3" />
          </a-form-item>
        </template>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
// 严格遵守 API 命名和导入规范 [cite: 1]
import { ExecuteOperation, ExecuteAfterSalesOperation, GetAfterSalesDetail } from '@/api/order';

export default {
  name: 'AfterSalesModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: () => ({})
    },
    opName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      detailData: null,
      confirmLoading: false,
      auditResult: 'pass',
      formState: {
        expressCompanyName: '',
        trackingNumber: '',
        serviceComment: ''
      }
    };
  },
  computed: {
    modalTitle() {
      if (this.opName === '售后审核') return '售后审核处理';
      return this.opName || '售后操作';
    },
    refundTotalFen() {
      const amount = Number(this.detailData?.payAmount) || 0;
      return Math.round(amount * 100);
    },
    actualOpName() {
      if (this.opName === '售后审核') {
        return this.auditResult === 'pass' ? '售后审核通过' : '售后审核拒绝';
      }
      return this.opName;
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.auditResult = 'pass';
        this.formState = {
          expressCompanyName: '',
          trackingNumber: '',
          serviceComment: ''
        };
        this.fetchDetail();
      } else {
        this.detailData = null;
      }
    }
  },
  methods: {
    formatTime(timeStr) {
      if (!timeStr) return '';
      return timeStr.replace('T', ' ');
    },
    async fetchDetail() {
      const targetUuid = this.detail?.uuid || this.detail?.id;
      if (!targetUuid) return;

      this.loading = true;
      try {
        // 必须使用 async/await 并包裹在 try...catch 中 [cite: 1]
        const res = await GetAfterSalesDetail({ uuid: targetUuid });

        if (res?.errCode === 0 && res?.data) {
          console.log(res.data);
          
          this.detailData = res.data;
        } else {
          this.$message.error(res?.message || '获取售后详情失败');
        }
      } catch (error) {
        console.error(error);
        this.$message.error('系统异常，获取详情失败');
      } finally {
        this.loading = false;
      }
    },
    async handleOk() {
      try {
        await this.$refs.formRef?.validate();
        this.confirmLoading = true;

        const isAfterSalesProcess = ['售后审核通过', '售后审核拒绝'].includes(this.actualOpName);

        // 核心修改：在此处统一将 serviceComment 挂载到 params 上，确保必定传给后端
        let params = {
          operation: this.actualOpName,
          uuid: this.detail?.uuid || this.detail?.id,
          serviceComment: this.formState.serviceComment
        };

        // 根据具体业务类型追加额外参数
        if (this.actualOpName === '售后审核通过') {
          const type = this.detailData?.afterSalesOrder?.type;
          if (type === '补寄') {
            params.expressCompanyName = this.formState.expressCompanyName;
            params.trackingNumber = this.formState.trackingNumber;
          } else if (type === '退货退款') {
            params.refundTotal = this.refundTotalFen;
            params.refundReason = '客户申请退货退款';
          }
        }

        // 动态分发 API [cite: 1]
        const apiCall = isAfterSalesProcess ? ExecuteAfterSalesOperation : ExecuteOperation;
        const res = await apiCall(params);

        if (res.errCode === 0) {
          this.$message.success('审核操作成功');
          // 单向数据流，通知父组件刷新 [cite: 1]
          this.$emit('refresh');
          // 必须使用 v-model:visible 绑定的方式关闭弹窗 [cite: 2, 3]
          this.$emit('update:visible', false);
        } else {
          this.$message.error(res.message || '操作失败');
        }
      } catch (error) {
        if (!error.errorFields) {
          this.$message.error('系统异常');
        }
      } finally {
        this.confirmLoading = false;
      }
    },
    handleCancel() {
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style scoped>
/* 必须使用 scoped [cite: 7] */
</style>